export default __webpack_public_path__ + "i18n/translations/translation-th.eeb241cb.json";